import { getEnumTranslationMap } from '../utils/get-enum-translation-map';

export enum PaymentMethod {
    BankTransfer = 'PAYMENT_METHOD_BANK_TRANSFER',
    Debit = 'PAYMENT_METHOD_DEBIT',
}

export const paymentMethodTranslationMap = getEnumTranslationMap(PaymentMethod);
